import { HANDOFF_PAYLOAD_HASH_KEY } from '../constants/investor-entry.constants';

const PREFIX = `${HANDOFF_PAYLOAD_HASH_KEY}=`;

// Not URLSearchParams: it decodes '+' as a space, corrupting a base64 blob that was never
// percent-encoded. Decoding only %XX escapes round-trips both encoded and raw.
export const parseHandoffPayload = (hash: string): string | null => {
  const fragment = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!fragment) return null;

  const entry = fragment.split('&').find((part) => part.startsWith(PREFIX));
  if (!entry) return null;

  const value = entry.slice(PREFIX.length);
  if (!value) return null;

  try {
    return decodeURIComponent(value);
  } catch {
    // Link mangled in transit — hand the raw value over rather than guess; the server answers 401.
    return value;
  }
};
